export const uiSchema = () => {
  return {
    contact_number: {
      "ui:widget": "text",
      "ui:placeholder": "Contact Number",
      "ui:options": {
        inputType: "tel",
        icon: "phone",
        iconPosition: "left",
      },
      "ui:help": "Enter your phone number (e.g., +1 234-567-8900)",
    },
    department: {
      "ui:widget": "select",
      "ui:placeholder": "Select Department",
      "ui:options": {
        icon: "university",
        iconPosition: "left",
        labeled: true,
        pointing: false,
      },
      "ui:help": "Your academic department or college",
    },
    program: {
      "ui:widget": "select",
      "ui:placeholder": "Select Program",
      "ui:options": {
        icon: "graduation cap",
        iconPosition: "left",
        labeled: true,
        pointing: false,
      },
      "ui:help": "Your degree program or course of study",
    },
    year: {
      "ui:widget": "select",
      "ui:placeholder": "Select Year",
      "ui:options": {
        icon: "calendar alternate",
        iconPosition: "left",
        labeled: true,
        pointing: false,
      },
      "ui:help": "Your current academic year level",
    },
    semester: {
      "ui:widget": "select",
      "ui:placeholder": "Select Semester",
      "ui:options": {
        icon: "calendar",
        iconPosition: "left",
        labeled: true,
        pointing: false,
      },
      "ui:help": "Your current academic semester",
    },
  };
};

export default uiSchema;
